import React, { useState, useLayoutEffect } from "react";
import { useScrollTrigger, CssBaseline, Slide } from "@material-ui/core";

export interface Props {
  isHideOnScroll?: boolean;
  children: React.ReactElement;
}

function HideOnScroll(props: Props) {
  const { children } = props;
  const trigger = useScrollTrigger({ target: undefined });
  const [upDownHeader, setUpDownHeader] = useState(false);

  useLayoutEffect(() => {
    setUpDownHeader(false);

    const handleScroll = () => {
      trigger ? setUpDownHeader(true) : setUpDownHeader(false);
    };

    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [trigger]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Slide appear={false} direction="down" in={!upDownHeader}>
        {children}
      </Slide>
    </React.Fragment>
  );
}

export default HideOnScroll;
